import frem from "frem"
frem({"width": 16, "height": 9})

import Yaafloop from "yaafloop"
import * as Preact from "preact"

import View from "views/Mount.view.js"
Preact.render(Preact.h(View), document.body, view)
